import { CIcon } from '~/icons/types'

export const ciMyClassifieds: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M19.9 9c.4 0 .7.1 1.1.2V9c0-1.7-1.3-3-3-3h-3.9c-.2 0-.4-.1-.5-.2l-2.1-2.1c-.5-.5-1-.7-1.6-.7H6C4.3 3 3 4.3 3 6v3.2c.3-.1.7-.2 1.1-.2h15.8Zm0 1.5H4.1c-1.4 0-2.4 1.2-2.2 2.6l.9 6c.1 1.1 1 1.9 2.2 1.9h14c1.1 0 2.1-.8 2.2-1.9l.9-6c.2-1.4-.8-2.6-2.2-2.6Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'my-classifieds',
  type: 'solid'
}
